import Divider from './component';
import enhance from './container';

export default enhance(Divider);
